import { render, staticRenderFns } from "./HighTransfer.vue?vue&type=template&id=a84b70bc"
import script from "./HighTransfer.vue?vue&type=script&lang=js"
export * from "./HighTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports